import classNames from 'classnames';
import React from 'react';
import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';

const OwnAiTitleStyles = styled(UiTypography)`
  body.dark & {
    color: #fff;
  }

  color: #000;
  margin: 8px 0 40px;
  padding: 0 16px;
`;

export const OwnAiTitle = React.forwardRef<
  HTMLHeadingElement,
  React.PropsWithChildren<{
    children: NonNullable<React.ReactNode>;
    className?: string;
  }>
>(function OwnAiTitle({ children, className }, ref) {
  return (
    <OwnAiTitleStyles
      ref={ref}
      className={classNames('own-ai-title', className)}
      variant={'title-medium'}
      align={'center'}
    >
      {children}
    </OwnAiTitleStyles>
  );
});

const OwnAiTitleHighlightStyles = styled.span`
  border-radius: 7px;
  background: linear-gradient(136deg, #7f36f3 -3.67%, #ed0d80 106.36%);
  padding: 4px 2px;
`;

export const OwnAiTitleHighlight: React.FC<{
  children?: NonNullable<React.ReactNode>;
  className?: string;
}> = ({ children, className }) => {
  return (
    <OwnAiTitleHighlightStyles className={className}>
      {children}
    </OwnAiTitleHighlightStyles>
  );
};
